import React from "react";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import Config from "conFig.js";
import { Error, Success } from "../../../assets/jss/util/messageUtil";

export default function Thembenxe() {
  const [tinhthanh, setTinhthanh] = React.useState([]);
  const [tinhthanhid, setTinhthanhid] = React.useState(0);
  const [ten, setTen] = React.useState("");
  const [diachi, setDiachi] = React.useState("");
  const [sodienthoai, setSodienthoai] = React.useState("");
  const [xaphuong, setXaphuong] = React.useState([]);
  const [xaphuongvalue, setXaphuongvalue] = React.useState(0);
  const [loaibenxe, setLoaibenxe] = React.useState(3);
  const [alert, setAlert] = React.useState(false);
  const [alert1, setAlert1] = React.useState(false);
  const [alertValidate, setAlertValidate] = React.useState(false);
  const [trickUpdateDefaultValue, setTrickUpdateDefaultValue] = React.useState(
    1
  );
  const [messageValidate, setMessageValidate] = React.useState("");
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const gettinhthanh = () => {
    var url = Config.backend + "/api/Diaphuong/gettinh?username=" + username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setTinhthanh(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const getxaphuongtheotinh = (id) => {
    var url =
      Config.backend +
      "/api/Donvi/getpxtheotinh?tinh=" +
      id +
      "&username" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setXaphuong(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const loaibenxeChange = (event) => {
    setLoaibenxe(event.target.value);
  };
  const insertbenxe = () => {
    let mess = validateThem();
    if (mess === Success.SC0001) {
      var url = Config.backend + "/api/Phuongtien/thembenxe";
      fetch(url, {
        method: "PUT",
        headers: {
          Accept: "application/json, text/plain",
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          tinh_id: tinhthanhid,
          ten: ten,
          phuongxa_id: xaphuongvalue,
          diachi: diachi,
          sodienthoai: sodienthoai,
          dmloaidonvi_id: loaibenxe,
          username: username,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data === 1) {
            showNotification();
          } else showNotification1();
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
        });
    } else {
      setMessageValidate(mess);
      showNotificationValidate();
    }
  };
  const showNotificationValidate = () => {
    setAlertValidate(true);
    setTimeout(function () {
      setAlertValidate(false);
    }, 6000);
  };
  const showNotification = () => {
    setAlert(true);
    setTimeout(function () {
      setAlert(false);
    }, 2000);
  };
  const showNotification1 = () => {
    setAlert1(true);
    setTimeout(function () {
      setAlert1(false);
    }, 2000);
  };
  const validateThem = () => {
    // Kiem tra cac truong bat buoc nhap
    if (!tinhthanhid || tinhthanhid === 0) {
      return Error.ER0009;
    }
    if (!xaphuongvalue || xaphuongvalue === 0) {
      return Error.ER0010;
    }
    return Success.SC0001;
  };
  React.useEffect(() => {
    gettinhthanh();
  }, []);
  return (
    <div>
      <CardBody style={{ borderBottom: "1px solid #bbb" }}>
        <GridContainer style={{ marginTop: 1 }}>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%" }}>
              <Autocomplete
                freeSolo
                disableClearable
                size="small"
                options={tinhthanh}
                getOptionLabel={(option) => option.ten}
                onChange={(event, value) => {
                  setXaphuongvalue(null);
                  getxaphuongtheotinh(value.id);
                  setTinhthanhid(value.id);
                  setTrickUpdateDefaultValue(
                    trickUpdateDefaultValue == 1 ? 2 : 1
                  );
                }}
                onInputChange={(event, newInputValue, reason) => {
                  if (reason !== "reset") {
                    setTinhthanhid(null);
                  } else {
                    setTinhthanhid(
                      tinhthanh.find(({ ten }) => ten === newInputValue).id
                    );
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Chọn tỉnh thành"
                    InputLabelProps={{
                      sx: {
                        color: "red",
                      },
                    }}
                    InputProps={{
                      ...params.InputProps,
                      type: "search",
                      style: {
                        height: "37px",
                        paddingTop: "initial",
                      },
                    }}
                  />
                )}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%" }}>
              <Autocomplete
                key={trickUpdateDefaultValue}
                freeSolo
                disableClearable
                size="small"
                options={xaphuong}
                getOptionLabel={(option) => option.ten}
                onChange={(event, value) => {
                  setXaphuongvalue(value.id);
                }}
                onInputChange={(event, newInputValue, reason) => {
                  if (reason !== "reset") {
                    setXaphuongvalue(null);
                  } else {
                    setXaphuongvalue(
                      xaphuong.find(({ ten }) => ten === newInputValue).id
                    );
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Chọn Xã/phường"
                    InputLabelProps={{
                      sx: {
                        color: "red",
                      },
                    }}
                    InputProps={{
                      ...params.InputProps,
                      type: "search",
                      style: {
                        height: "35px",
                        paddingTop: "initial",
                      },
                    }}
                  />
                )}
              />
            </FormControl>
          </GridItem>
        </GridContainer>
        <GridContainer style={{ marginTop: 15 }}>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%" }}>
              <TextField
                label="Tên bến xe"
                variant="outlined"
                value={ten}
                size="small"
                onChange={(event) => {
                  setTen(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%" }}>
              <TextField
                label="Địa chỉ"
                variant="outlined"
                value={diachi}
                size="small"
                onChange={(event) => {
                  setDiachi(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
        </GridContainer>
        <GridContainer style={{ marginTop: 15 }}>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%" }}>
              <TextField
                label="Số điện thoại"
                variant="outlined"
                size="small"
                value={sodienthoai}
                onChange={(event) => {
                  setSodienthoai(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%" }}>
              <InputLabel style={{ marginTop: "-8px" }}>Loại bến xe</InputLabel>
              <Select
                value={loaibenxe}
                onChange={loaibenxeChange}
                size="small"
                style={{ height: 35 }}
              >
                <MenuItem value={3}>Bến xe khách</MenuItem>
                <MenuItem value={8}>Bến xe hàng</MenuItem>
              </Select>
            </FormControl>
          </GridItem>
        </GridContainer>
      </CardBody>
      {/** fix css */}
      <CardFooter style={{ marginBottom: "20px" }}>
        <Button
          color="primary"
          variant="contained"
          style={{ height: 27 }}
          onClick={insertbenxe}
        >
          Thêm
        </Button>
      </CardFooter>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="info"
            icon={AddAlert}
            message="Thêm thành công"
            open={alert}
            closeNotification={() => setAlert(false)}
            close
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message="Có lỗi trong quá trình thêm"
            open={alert1}
            closeNotification={() => setAlert1(false)}
            close
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message={messageValidate}
            open={alertValidate}
            closeNotification={() => setAlertValidate(false)}
            close
          />
        </GridItem>
      </GridContainer>
    </div>
  );
}
